export default {
  // Examples of tournament/bets format
  tournament: {
    tournamentId: 7,
    nextRace: {
      raceId: 13,
      racer1: {
        id: 12,
        name: 'Racer One',
        odds: {
          race: 1.85,
          quarterFinals: null,
          semiFinals: 4.40,
          finals: 10.35,
        },
        latestRaces: [
          false,
          false,
          false,
          true,
          true,
        ],
      },
      racer2: {
        id: 15,
        name: 'Racer Two',
        odds: {
          race: 2.45,
          quarterFinals: null,
          semiFinals: 5.90,
          finals: 12.35,
        },
        latestRaces: [
          true,
          true,
          false,
          false,
          true,
        ],
      },
      headToHead: [
        19,
        12,
        12,
        19,
        19,
      ],
    },
    schedule: [
      {
        raceId: 13,
        raceTime: 1579618411,
        racer1: {
          id: 12,
          name: 'Racer One',
          odds: 1.85,
        },
        racer2: {
          id: 16,
          name: 'Racer Five',
          odds: 2.45,
        },
      },
      {
        raceId: 14,
        raceTime: 1579618411,
        racer1: {
          id: 13,
          name: 'Racer Two',
          odds: 1.85,
        },
        racer2: {
          id: 17,
          name: 'Racer Six',
          odds: 2.45,
        },
      },
      {
        raceId: 15,
        raceTime: 1579618411,
        racer1: {
          id: 14,
          name: 'Racer Three',
          odds: 1.85,
        },
        racer2: {
          id: 19,
          name: 'Racer Eight',
          odds: 2.45,
        },
      },
    ],
    outrights: [
      {
        racerId: 12,
        racerName: 'Racer One',
        odds: {
          quarterFinals: null,
          semiFinals: null,
          finals: 10.35,
        },
      },
      {
        racerId: 13,
        racerName: 'Racer Two',
        odds: {
          quarterFinals: null,
          semiFinals: 4.40,
          finals: 10.35,
        },
      },
      {
        racerId: 14,
        racerName: 'Racer Three',
        odds: {
          quarterFinals: null,
          semiFinals: 4.40,
          finals: 10.35,
        },
      },
      {
        racerId: 15,
        racerName: 'Racer Four',
        odds: null,
      },
      {
        racerId: 16,
        racerName: 'Racer Five',
        odds: {
          quarterFinals: null,
          semiFinals: null,
          finals: 10.35,
        },
      },
      {
        racerId: 17,
        racerName: 'Racer Six',
        odds: {
          quarterFinals: null,
          semiFinals: 4.40,
          finals: 10.35,
        },
      },
      {
        racerId: 18,
        racerName: 'Racer Seven',
        odds: null,
      },
      {
        racerId: 19,
        racerName: 'Racer Eight',
        odds: {
          quarterFinals: null,
          semiFinals: 4.40,
          finals: 10.35,
        },
      },
    ],
  },
  betsMap: {
    h2h: 'headToHead',
  },
  shortNames: {
    eighthFinals: '1/8',
    quarterFinals: '1/4',
    semiFinals: '1/2',
    finals: 'F',
    tournament: 'T',
  },
};
